import { render, staticRenderFns } from "./readmore.vue?vue&type=template&id=2af1b17f&"
import script from "./readmore.vue?vue&type=script&lang=js&"
export * from "./readmore.vue?vue&type=script&lang=js&"
import style0 from "./readmore.vue?vue&type=style&index=0&id=2af1b17f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports